var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"section1"}},[_c('div',{staticClass:"fondoSilver"},[_c('b-img',{staticClass:"imgContS5",staticStyle:{"height":"30vh"},attrs:{"src":_vm.payImg}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }